import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsPolicyHolderAndEncoresFlagTrueRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const foreignCustomerId = control.get('foreignCustomerId')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const coverProcessId = control.get('coverProcessId')!.value;

	return  documentCategory === 'EGD03' && (!!coverProcessId || !!foreignCustomerId) ?
		{ checkDocCategoryIsPolicyHolderAndEncoresFlagTrueFlag: true } : null;

};
